let HandleResponse = {
  data: function () {
    return {
      response: {
        errors: null,
        message: null,
      }
    };
  },
  methods: {
    handleResponseClear: function () {
      this.response = {
        errors: null,
        message: null,
      };
    },
    handleResponseErrors: function (responseJSON) {
      if (responseJSON.errors) {
        let messages = [];

        for (const [value, text] of Object.entries(responseJSON.errors)) {
          text.forEach((el) => {
            messages.push(el);
          });
        }

        this.response.errors = messages;
      } else {
        this.response.errors = [responseJSON.message];
      }
    },
    handleResponseMessage: function (responseJSON) {
      if (responseJSON.errors) {
        this.handleResponseErrors(responseJSON);
      } else {
        this.response.message = responseJSON.message;
      }
    }
  },
};

export default HandleResponse;
